import { describeCron } from "@prodgy/schedule";

import { getLocalizedText } from "@/shared/utils/i18nHelper";

import type { Job, JobLive } from "../types/job";

/**
 * O que a lista mostra de um job (AB#87442): a versão em vigor nas colunas, e o
 * rascunho só no resumo das alterações pendentes.
 */

/** O que roda de fato: a versão publicada, ou o rascunho de um job nunca publicado. */
export function liveViewOf(job: Job): JobLive {
  return job.live ?? { instruction: job.instruction, trigger: job.trigger, schedule_description: job.schedule_description };
}

/** O agendamento em frase, no idioma de quem lê; vazio num webhook. */
export function scheduleText(view: Pick<JobLive, "trigger" | "schedule_description">, locale: string): string {
  if (view.trigger.type !== "schedule") return "";
  if (view.schedule_description) return getLocalizedText(view.schedule_description, locale);
  return describeCron(view.trigger.cron, {
    locale: locale === "pt" ? "pt" : "en",
    timezone: view.trigger.timezone,
  });
}

/**
 * A recomendação da confirmação de publicar: executar antes, quando esta versão
 * não rodou (ou ainda está rodando), ou rodou e falhou. Publicar nunca é bloqueado.
 */
export function publishRecommendation(job: Job): "notRun" | "failed" | null {
  const status = job.pending?.manual_run.status;
  if (!status || status === "completed") return null;
  return status === "failed" ? "failed" : "notRun";
}
